<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新建配置"
      width="1000px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="100px">
        <el-form-item label="币种：" prop="coinType">
          <el-select v-model="detail.coinType" placeholder="请选择">
            <el-option
              v-for="item in coinList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="阈值:" prop="value">
          <el-input-number v-model="detail.value" :min="0"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'addCold',
  data() {
    return {
      dialogVisible: false,
      detail: {
        coinType: '',
        value: ''
      },
      rules: {
        value: {
          required: true,
          message: '请填写'
        }
      }
    };
  },

  computed: {
    ...mapState('coldSetting', ['coinList'])
  },
  methods: {
    ...mapActions('coldSetting', ['listAllCoin', 'addCold', 'getList']),
    closeDialog() {
      // this.$refs["form"].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.addCold(this.detail).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.getList();
      });
    }
  },
  created() {
    this.listAllCoin();
  }
};
</script>

<style lang="less"></style>
